// extracted by mini-css-extract-plugin
export var LeftAlign = "imageWithCopySlider-module--LeftAlign--07361";
export var ctaContainer = "imageWithCopySlider-module--ctaContainer--10244";
export var description = "imageWithCopySlider-module--description--50b9e";
export var imagePanel = "imageWithCopySlider-module--imagePanel--86ee1";
export var imageWrapper = "imageWithCopySlider-module--imageWrapper--b6ded";
export var imagesecond = "imageWithCopySlider-module--imagesecond--f2e8c";
export var item = "imageWithCopySlider-module--item--e504f";
export var items = "imageWithCopySlider-module--items--c5b19";
export var next = "imageWithCopySlider-module--next--72fb4";
export var panel = "imageWithCopySlider-module--panel--e7804";
export var panelContainer = "imageWithCopySlider-module--panelContainer--81ecb";
export var panelContent = "imageWithCopySlider-module--panelContent--21aa9";
export var panelData = "imageWithCopySlider-module--panelData--7d668";
export var panelTitle = "imageWithCopySlider-module--panelTitle--e07b4";
export var prev = "imageWithCopySlider-module--prev--0995e";
export var primaryImage = "imageWithCopySlider-module--primaryImage--26703";
export var stacked = "imageWithCopySlider-module--stacked--31383";
export var wrapper = "imageWithCopySlider-module--wrapper--3f54b";